import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IPagination } from 'src/app/shared/models/pagination';
import { environment } from 'src/environments/environment';
import { PurchaseOrder } from '../interfaces/Iip-purchase-order';
import ContractPurchaseOrder from '../interfaces/ip-contract-purchase-order';
import { PageResponse } from '../interfaces/ip-page-response';
import PurchaseOrderResponse from '../interfaces/ip-purchase-order-response';
import { QueryParametersService } from './ip-query-parameter.service';

@Injectable({
  providedIn: 'root',
})
export class IpPurchaseOrderService {
  api = environment.api;

  constructor(
    private http: HttpClient,
    private queryParameterService: QueryParametersService,
  ) { }

  getData(
    pagination: IPagination,
    sortFieldName: string = 'creationDate',
    sortOrder: string = 'desc',
    searchName: string = '',
    searchValue: string = '',
  ): Observable<PageResponse<PurchaseOrderResponse>> {
    const params = this.queryParameterService.buildQueryParameters(
      sortFieldName,
      sortOrder,
      pagination,
      searchName,
      searchValue,
    );
    return this.http.get<PageResponse<PurchaseOrderResponse>>(
      `${this.api}/invopay/purchase-orders`,
      { params }
    );
  }

  getPurchaseOrders(): Observable<PageResponse<PurchaseOrderResponse>> {
    return this.http.get<PageResponse<PurchaseOrderResponse>>(
      `${this.api}/invopay/purchase-orders`
    );
  }

  createPurchaseOrder(request: PurchaseOrder): Observable<PurchaseOrder> {
    return this.http.post<PurchaseOrder>(
      `${this.api}/invopay/purchase-orders`,
      request
    );
  }

  updatePurchaseOrder(id: number, request: PurchaseOrder): Observable<PurchaseOrder> {
    return this.http.put<PurchaseOrder>(
      `${this.api}/invopay/purchase-orders/${id}`,
      request
    );
  }

  deletePurchaseOrder(id: number): Observable<PurchaseOrder> {
    return this.http.delete<PurchaseOrder>(
      `${this.api}/invopay/purchase-orders/${id}`
    );
  }

  getAvailablePurchaseOrders(): Observable<Array<ContractPurchaseOrder>> {
    return this.http.get<Array<ContractPurchaseOrder>>(
      `${this.api}/invopay/purchase-orders/available/supplier`
    );
  }

  getAvailablePurchaseOrdersBySupplierId(supplierId: number):
    Observable<Array<ContractPurchaseOrder>> {
    return this.http.get<Array<ContractPurchaseOrder>>(
      `${this.api}/invopay/purchase-orders/available/enterprise/${supplierId}`
    );
  }
}
